import "./Portfolio.module.css";
import Navigation from "@/reusable_sections/Header";
import Portfolio from "./sections/Portfolio";
import QualitTBrauchtZeit from "./sections/QualitTBrauchtZeit";
import Transformation from "./sections/Transformation";
import Footer from "@/reusable_sections/Footer";
export default function PortfolioPage() {
  return <div>
      <Navigation />
      <Portfolio />
      <QualitTBrauchtZeit />
      <Transformation />
      <Footer />
    </div>;
}